// extracted by mini-css-extract-plugin
export default {"seventh_wrapper":"seventh_seventh_wrapper__RZDUB"};